import { useState, useContext } from 'react'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'
import { UsuarioContext } from '../../../contexts/UsuarioContext'

const useHoraFixa = () => {
  const { actionsHoraFixa } = useContext(AgendamentoContext)
  const { userUCtx } = useContext(UsuarioContext)
  const [semAcesso, setSemAcesso] = useState(false)

  async function BuscarHoraFixaId(idmensalista: number) {
    const horariosFixos = await actionsHoraFixa.BuscarHoraFixaId(idmensalista)
    return horariosFixos
  }

  function verificarAcessoUsuario(horariosFixos: any) {
    if (horariosFixos.usuario.idusuario !== userUCtx.usuario.idusuario) return setSemAcesso(true)
    else return setSemAcesso(false)
  }

  return { verificarAcessoUsuario, BuscarHoraFixaId, semAcesso }
}

export default useHoraFixa
